export default {
    april: 'April',
    august: 'August',
    december: 'December',
    february: 'February',
    january: 'January',
    july: 'July',
    june: 'June',
    march: 'March',
    may: 'May',
    month: 'Month',
    november: 'November',
    october: 'October',
    september: 'September',
    today: 'Today',
    year: 'Year',
    yesterday: 'Yesterday',
}
